import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, Toggle } from "material-ui"
import strings from "../../localization/strings"
import { IPayTypeBudget } from "../../models"
import PayTypeSelector from "../paytype/PayTypeSelector"
import DoubleField from "../common/DoubleField"
import _ from "lodash"
import * as jobHelper from "../../helpers/jobHelper"
import AccountStore from "../../stores/AccountStore"

interface IProps {
    readonly?: boolean
    editJobPayTypeBudgetItem: IPayTypeBudget
    exitJobPayTypeBudgetItems: IPayTypeBudget[]
    handleClose(): void
    handleAdd(item: IPayTypeBudget): void
    handleUpdate(item: IPayTypeBudget): void
}
interface IState {
    selectedPayTypeId: string
    errorSelectedPayTypeId: string
    weeklyBudgetInHours: string
    errorWeeklyBudgetInHours: string
    weeklyBudgetAmount: string
    errorWeeklyBudgetAmount: string
    isRegular: boolean
    isOT: boolean
    isOT2: boolean
    duplicated: boolean
}

export default class AddJobDetailPayTypeBudgetDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            selectedPayTypeId: props.editJobPayTypeBudgetItem ? props.editJobPayTypeBudgetItem.PayTypeId : null,
            errorSelectedPayTypeId: null,
            weeklyBudgetInHours: props.editJobPayTypeBudgetItem ? props.editJobPayTypeBudgetItem.WeeklyBudgetInHours.toString() : "0",
            errorWeeklyBudgetInHours: null,
            weeklyBudgetAmount: props.editJobPayTypeBudgetItem ? props.editJobPayTypeBudgetItem.WeeklyBudgetAmount.toString() : "0",
            errorWeeklyBudgetAmount: null,
            isRegular: props.editJobPayTypeBudgetItem ? props.editJobPayTypeBudgetItem.RegularTime : false,
            isOT: props.editJobPayTypeBudgetItem ? props.editJobPayTypeBudgetItem.OTTime : false,
            isOT2: props.editJobPayTypeBudgetItem ? props.editJobPayTypeBudgetItem.OT2Time : false,
            duplicated: false
        }

        autobind(this)
    }

    handleSave() {
        if (!this.checkValidate()) return

        const payload = this.props.editJobPayTypeBudgetItem ? _.cloneDeep(this.props.editJobPayTypeBudgetItem) : {} as IPayTypeBudget
        payload.PayTypeId = jobHelper.getPayTypeId(this.state.isRegular, this.state.isOT, this.state.isOT2, this.state.selectedPayTypeId)
        payload.WeeklyBudgetInHours = parseFloat(this.state.weeklyBudgetInHours)
        payload.WeeklyBudgetAmount = parseFloat(this.state.weeklyBudgetAmount)
        payload.RegularTime = this.state.isRegular
        payload.OTTime = this.state.isOT
        payload.OT2Time = this.state.isOT2

        this.props.editJobPayTypeBudgetItem ?
            this.props.handleUpdate(payload) :
            this.props.handleAdd(payload)

        this.props.handleClose()
    }

    checkValidate() {
        let validate = true

        if (!this.state.isRegular && !this.state.isOT && !this.state.isOT2) {
            if (!this.state.selectedPayTypeId) {
                this.setState({ errorSelectedPayTypeId: strings.This_field_is_required })
                validate = false
            }
            else {
                this.setState({ errorSelectedPayTypeId: null })
            }
        }

        if (this.state.weeklyBudgetInHours === "") {
            this.setState({ errorWeeklyBudgetInHours: strings.This_field_is_required })
            validate = false
        }
        else {
            this.setState({ errorWeeklyBudgetInHours: null })
        }

        if (this.state.weeklyBudgetAmount === "") {
            this.setState({ errorWeeklyBudgetAmount: strings.This_field_is_required })
            validate = false
        }
        else {
            this.setState({ errorWeeklyBudgetAmount: null })
        }

        const exitJobPayTypeBudgetItems = _.cloneDeep(this.props.exitJobPayTypeBudgetItems)
        const compareJobPayTypeBudgetItems = this.props.editJobPayTypeBudgetItem ?
            exitJobPayTypeBudgetItems.filter(i => !jobHelper.checkSamePayTypeBudgetExist(this.props.editJobPayTypeBudgetItem.RegularTime, this.props.editJobPayTypeBudgetItem.OTTime, this.props.editJobPayTypeBudgetItem.OT2Time, this.props.editJobPayTypeBudgetItem.PayTypeId, i)) :
            exitJobPayTypeBudgetItems
        if (compareJobPayTypeBudgetItems.find(i => jobHelper.checkSamePayTypeBudgetExist(this.state.isRegular, this.state.isOT, this.state.isOT2, this.state.selectedPayTypeId, i))) {
            this.setState({ duplicated: true })
            validate = false
        }
        else {
            this.setState({ duplicated: false })
        }

        return validate
    }

    render() {
        return (
            <Dialog
                open
                autoScrollBodyContent
                title={this.props.editJobPayTypeBudgetItem ? strings.EditJobBudgetItem : strings.NewJobBudgetItem}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={this.props.readonly ?
                    <FlatButton data-intercom-target={"JobBudgetPayType-Btn-CloseAddExpenseDialog"} label={strings.CANCEL} secondary onClick={this.props.handleClose} /> :
                    [this.state.duplicated &&
                        <span style={{ fontSize: 19, marginRight: 75, color: "#F57C00" }}>
                            {strings.Duplicate_Budget_Item_Message_Text}
                        </span>,
                    <FlatButton data-intercom-target={"JobBudgetPayType-Btn-CloseAddExpenseDialog"} label={strings.CANCEL} secondary onClick={this.props.handleClose} />,
                    <FlatButton data-intercom-target={"JobBudgetPayType-Btn-SaveExpense"} label={strings.SAVE} primary onClick={this.handleSave} />
                    ]
                }
            >
                <hr />

                <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: 1 }}>
                            <Toggle
                                data-intercom-target={"JobBudgetPayType-Toggle-Regular"}
                                label={strings.RegularTimeLabel}
                                style={{ width: 125, marginTop: 25 }}
                                toggled={this.state.isRegular}
                                onToggle={(e, value) => this.setState({ isRegular: value, isOT: false, isOT2: false }, () => this.checkValidate())}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <Toggle
                                data-intercom-target={"JobBudgetPayType-Toggle-Overtime"}
                                label={strings.OvertimeLabel}
                                style={{ width: 125, marginTop: 25 }}
                                toggled={this.state.isOT}
                                onToggle={(e, value) => this.setState({ isRegular: false, isOT: value, isOT2: false }, () => this.checkValidate())}
                            />
                        </div>
                        {!AccountStore.getHideOT2() &&
                            <div style={{ flex: 1 }}>
                                <Toggle
                                    data-intercom-target={"JobBudgetPayType-Toggle-DoubleOvertime"}
                                    label={strings.DoubleOvertimeLabel}
                                    style={{ width: 125, marginTop: 25 }}
                                    toggled={this.state.isOT2}
                                    onToggle={(e, value) => this.setState({ isRegular: false, isOT: false, isOT2: value }, () => this.checkValidate())}
                                />
                            </div>
                        }
                    </div>
                    {!this.state.isRegular && !this.state.isOT && !this.state.isOT2 &&
                        <div style={{ display: "flex" }}>
                            <div style={{ flex: 1 }}>
                                <PayTypeSelector
                                    allowAllPayTypes
                                    selectedPayTypeId={this.state.selectedPayTypeId}
                                    errorSelectedPayTypeId={this.state.errorSelectedPayTypeId}
                                    handleSelect={(selectedPayTypeId) => this.setState({ selectedPayTypeId }, () => this.checkValidate())}
                                    readonly={this.props.readonly}
                                />
                            </div>
                        </div>
                    }
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: 1 }}>
                            <DoubleField
                                name="WeeklyBudgetInHours"
                                label={strings.WeeklyHourlyBudget}
                                value={this.state.weeklyBudgetInHours}
                                handleChange={weeklyBudgetInHours => this.setState({ weeklyBudgetInHours }, () => this.checkValidate())}
                                error={this.state.errorWeeklyBudgetInHours}
                            /> {strings.Hours}
                        </div>
                        <div style={{ flex: 1 }}>
                            $ <DoubleField
                                name="WeeklyBudgetAmount"
                                label={strings.WeeklyAmountBudget}
                                value={this.state.weeklyBudgetAmount}
                                handleChange={weeklyBudgetAmount => this.setState({ weeklyBudgetAmount }, () => this.checkValidate())}
                                error={this.state.errorWeeklyBudgetAmount}
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        )
    }
}